export const EXTERNAL_SYNC_PROVIDERS = /** @type {const} */ ({
  SHAREPOINT: 'sharepoint',
  POLICYTECH: 'policytech',
});

/** @typedef {(typeof EXTERNAL_SYNC_PROVIDERS)[keyof typeof EXTERNAL_SYNC_PROVIDERS]} ExternalSyncProvider */
